import React, { Component } from 'react';
import Select from 'components/Select';

class Preferences extends Component {
  sortByName(list) {
    if (!list) {
      return [];
    }

    return Object.keys(list).sort(function(a, b) {
      var nameA = list[a].toUpperCase();
      var nameB = list[b].toUpperCase();

      if (nameA < nameB) {
        return -1;
      }

      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  }

  formatSelectOption(list, dataList) {
    var result = [];

    if (list) {
      list.forEach(function(val) {
        result.push({
          label: dataList[val],
          value: parseInt(val, 10)
        });
      });
    }

    return result;
  }

  render() {
    var dataArray = this.props.dataArray || {};
    var user = this.props.user || {};

    var ingredientList =
      dataArray.ingredientList || {};
    var dishGroups =
      dataArray.dishGroups || {};

    var dislikes =
      this.props.dislikes || [];
    var eliminateGroups =
      this.props.eliminate_groups || [];

    var ingredientKeys =
      this.sortByName(ingredientList);

    var ingredientListData =
      this.formatSelectOption(
        ingredientKeys,
        ingredientList
      );

    var dishGroupList =
      this.formatSelectOption(
        Object.keys(dishGroups),
        dishGroups
      );

    var dislikeList =
      user.dislikes &&
      ingredientList &&
      dislikes.length === 0
        ? this.formatSelectOption(
            user.dislikes,
            ingredientList
          )
        : dislikes;

    var eliminateList =
      user.eliminate_groups &&
      dishGroups &&
      eliminateGroups.length === 0
        ? this.formatSelectOption(
            user.eliminate_groups,
            dishGroups
          )
        : eliminateGroups;

    return (
      <div className="step-form-group">
        <h5>Preferences</h5>

        <div className="popup-select-area step-form-input">
          <label className="food-prefs-header">
            Eliminate
          </label>

          <Select
            multiple={true}
            isgrouped={true}
            placeholder="Change Eliminate"
            list={dishGroupList}
            value={eliminateList || []}
            isSearchable={true}
            name="eliminate_groups"
            onChange={function(
              name,
              value
            ) {
              this.props.onEliminateChange(
                value
              );
            }.bind(this)}
          />
        </div>

        <div className="popup-select-area step-form-input">
          <label className="food-prefs-header">
            Dislikes
          </label>

          <Select
            multiple={true}
            isgrouped={true}
            placeholder="Change Dislikes"
            list={ingredientListData}
            value={dislikeList || []}
            isSearchable={true}
            name="dislikes"
            onChange={function(
              name,
              value
            ) {
              this.props.onDislikeChange(
                value
              );
            }.bind(this)}
          />
        </div>

        <p className="note">
          *Note: Certain ingredients cannot be
          avoided and if more than three, please
          consult.
        </p>
      </div>
    );
  }
}

export default Preferences;
